import React from 'react'
import Grid from '@material-ui/core/Grid'
import { RequiredInput } from './input'

export type ContactPersonalInfo = {
  firstName: string;
  lastName: string;
  phone: string;
}

export interface ContactPersonalInfoFormProps {
  value: ContactPersonalInfo;
  onChange: (person: ContactPersonalInfo) => void;
  disabled?: boolean;
}

export const ContactPersonalInfoForm: React.FC<ContactPersonalInfoFormProps> = function (props) {
  const { value: person, onChange, disabled = false } = props

  function update (key: string, value: any): void {
    onChange({
      ...person,
      [key]: value
    })
  }
  return (
    <Grid container spacing={2} direction="column" >
      <Grid item xs>
        <RequiredInput value={person.firstName} disabled={disabled} onChange={value => update('firstName', value)} label='Imię' />
      </Grid>
      <Grid item xs>
        <RequiredInput value={person.lastName} disabled={disabled} onChange={value => update('lastName', value)} label='Nazwisko' />
      </Grid>
      <Grid item xs>
        <RequiredInput value={person.phone} label="Numer telefonu" disabled={disabled} onChange={value => update('phone', value)} />
      </Grid>
    </Grid>
  )
}
